module.exports = __webpack_public_path__ + "static/media/A9DDCFC7-5CBE-476D-91CE-A6CE4B6785D0.bd58cbc5.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/綜合司康/A9DDCFC7-5CBE-476D-91CE-A6CE4B6785D0.JPG
// module id = 233
// module chunks = 0